import React from 'react';
import {Link} from 'react-router';
import General from '../../modules/General';

const NoResult = ({button,link,header,body,action}) => (
	<div className="offset-sm-3 col-md-6 no-results">
		<div className="panel panel-bordered" style={{border:'1px solid #e4eaec'}}>
			<div className="panel-body text-center" style={{textAlign:'center'}}><br />
				<i className="icon wb-alert-circle" aria-hidden="true" style={{fontSize:'80px'}}></i>
				<p>
				<br />
				{header}
				<br />

				{body}</p>

				{link && !action ? <Link to={General.Link(link)} className="btn btn-default">{button}</Link>:null}
                {!link && action ? <button onClick={action} className="btn btn-default">{button}</button>:null}

				<br />
			</div>
		</div>
	</div>
);

export default NoResult;


// WEBPACK FOOTER //
// ./components/general/NoResult.js